'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = translate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _en = require('./en');

var _en2 = _interopRequireDefault(_en);

var _es = require('./es');

var _es2 = _interopRequireDefault(_es);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languages = { en: _en2.default, es: _es2.default };

function translate(key) {
    return function (Component) {
        var _class, _temp;

        var stateToProps = function stateToProps(state, key) {
            return {
                currentLanguage: state.language.lang,
                key: key
            };
        };

        var TranslationComponent = (_temp = _class = function (_React$Component) {
            (0, _inherits3.default)(TranslationComponent, _React$Component);

            function TranslationComponent() {
                (0, _classCallCheck3.default)(this, TranslationComponent);
                return (0, _possibleConstructorReturn3.default)(this, (TranslationComponent.__proto__ || (0, _getPrototypeOf2.default)(TranslationComponent)).apply(this, arguments));
            }

            (0, _createClass3.default)(TranslationComponent, [{
                key: 'render',
                value: function render() {
                    var strings = languages[this.props.currentLanguage][key];
                    var merged = (0, _extends3.default)({}, this.props.strings, strings);
                    if (strings) {
                        return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, {
                            strings: merged,
                            currentLanguage: this.props.currentLanguage
                        }));
                    }

                    return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, {
                        currentLanguage: this.props.currentLanguage
                    }));
                }
            }]);
            return TranslationComponent;
        }(_react2.default.Component), _class.displayName = key, _temp);


        TranslationComponent.propTypes = {
            strings: _react2.default.PropTypes.object,
            currentLanguage: _react2.default.PropTypes.string,
            key: _react2.default.PropTypes.string
        };

        return (0, _reactRedux.connect)(stateToProps)(TranslationComponent);
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/i18n/translate.js
// module id = 54
// module chunks = 0